module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "viewContainer"
  }, [_c('el-tabs', {
    staticClass: "el-tabs",
    attrs: {
      "type": "card"
    },
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "我的联盟",
      "name": "first"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "入盟邀请",
      "name": "second"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "我的员工",
      "name": "third"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "店铺(员工)码",
      "name": "fourth"
    }
  }), _vm._v(" "), (_vm.youLmId == 1) ? _c('el-tab-pane', {
    attrs: {
      "label": "联盟活动",
      "name": "fifth"
    }
  }) : _vm._e(), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "数据统计",
      "name": "sixth"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeName == 'first'),
      expression: "activeName=='first'"
    }],
    staticClass: "main_container"
  }, [(_vm.statusMA == 1) ? _c('div', [_c('el-form', {
    staticClass: "findform",
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "30%"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "placeholder": "搜索联盟名称",
      "maxlength": "20"
    },
    model: {
      value: (_vm.filters.EnterpriseName),
      callback: function($$v) {
        _vm.$set(_vm.filters, "EnterpriseName", $$v)
      },
      expression: "filters.EnterpriseName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("搜索")])], 1), _vm._v(" "), _c('el-form-item', [(_vm.isCreateMA == 0) ? _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.createAllianceAddFun
    }
  }, [_vm._v("申请创建联盟")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "reminder"
  }, [_vm._v("温馨提示：1. 您的用户会只能看到当前主推联盟商家信息； 2.只能设置一个主推联盟")]), _vm._v(" "), _c('div', {
    staticClass: "table_container"
  }, [_c('el-table', {
    attrs: {
      "data": _vm.tableListOne,
      "stripe": "",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "align": "center",
      "width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.$index + 1))])]
      }
    }], null, false, 4178052834)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "联盟名称",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "spanList",
          attrs: {
            "title": scope.row.name
          }
        }, [_vm._v(_vm._s(scope.row.name))])]
      }
    }], null, false, 3754464004)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "联盟联系人",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.contacts))]
      }
    }], null, false, 805193294)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "联系电话",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.contactsPhone))]
      }
    }], null, false, 1248487762)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "身份",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.identityName))]
      }
    }], null, false, 3584246604)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "时间",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.time))]
      }
    }], null, false, 2176227688)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.stateName))]
      }
    }], null, false, 2867331277)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "fixed": "right",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.identity == 1 && scope.row.state == 1) ? _c('span', {
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.operationButton(scope.row, 1)
            }
          }
        }, [_vm._v(" 取消申请 ")]) : _vm._e(), _vm._v(" "), (scope.row.isMainMA == 1) ? _c('span', {
          staticClass: "red"
        }, [_vm._v(" 当前主推 ")]) : _vm._e(), _vm._v(" "), (scope.row.isMainMA == 0 && scope.row.state == 2) ? _c('span', {
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.operationButton(scope.row, 2)
            }
          }
        }, [_vm._v(" 设为主推 ")]) : _vm._e(), _vm._v(" "), (scope.row.identity == 0 && scope.row.state == 2) ? _c('span', {
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.operationButton(scope.row, 3)
            }
          }
        }, [_vm._v(" 退出 ")]) : _vm._e(), _vm._v(" "), (scope.row.identity == 0 && scope.row.state == 2) ? _c('span', {
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.operationButton(scope.row, 4)
            }
          }
        }, [_vm._v(" 查看 ")]) : _vm._e(), _vm._v(" "), (scope.row.identity == 1 && scope.row.state == 2) ? _c('span', {
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.operationButton(scope.row, 5)
            }
          }
        }, [_vm._v(" 管理联盟 ")]) : _vm._e()]
      }
    }], null, false, 3580046917)
  })], 1), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "margin": "10px 0",
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "current-page": _vm.lmpageIndex,
      "page-size": 10,
      "total": _vm.lmtotalRowsCount
    },
    on: {
      "current-change": _vm.handleTablm
    }
  })], 1), _vm._v(" "), (_vm.tableListOne.length < 1) ? _c('div', {
    staticClass: "reminder",
    staticStyle: {
      "font-weight": "bold",
      "margin-top": "15px"
    }
  }, [_vm._v("您当前还没加入或创建任何联盟，"), _c('span', {
    staticClass: "btn_operation",
    on: {
      "click": _vm.createAllianceAddFun
    }
  }, [_vm._v("申请创建联盟")]), _vm._v(" 或 去看看 "), _c('span', {
    staticClass: "btn_operation",
    on: {
      "click": _vm.goInvite
    }
  }, [_vm._v("入盟邀请")]), _vm._v(" 吧!")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.statusMA == 2) ? _c('div', {
    staticStyle: {
      "padding-bottom": "100px"
    }
  }, [_c('p', {
    staticClass: "reminder"
  }, [_c('img', {
    staticClass: "faceUrl",
    attrs: {
      "src": _vm.basicInformation.logoUrl
    }
  }), _vm._v("\r\n        联盟名称:" + _vm._s(_vm.basicInformation.name) + "　　联盟联系人:" + _vm._s(_vm.basicInformation.contacts) + "　　联系电话:" + _vm._s(_vm.basicInformation.contactsPhone) + "\r\n      ")]), _vm._v(" "), _c('el-form', {
    staticClass: "findform",
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "50%"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "placeholder": "搜索店铺名称",
      "maxlength": "20"
    },
    model: {
      value: (_vm.filters.EnterpriseName),
      callback: function($$v) {
        _vm.$set(_vm.filters, "EnterpriseName", $$v)
      },
      expression: "filters.EnterpriseName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("查询")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "table_container"
  }, [_c('el-table', {
    attrs: {
      "data": _vm.threeMAList,
      "stripe": "",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "align": "center",
      "width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.$index + 1))])]
      }
    }], null, false, 4178052834)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "店铺名称",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "spanList",
          attrs: {
            "title": scope.row.name
          }
        }, [_vm._v(_vm._s(scope.row.name))])]
      }
    }], null, false, 3754464004)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "负责人",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.contacts))]
      }
    }], null, false, 805193294)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "联系电话",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.phone))]
      }
    }], null, false, 2034370561)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "店铺类型",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.bbTypeName))]
      }
    }], null, false, 1483970594)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "加入时间",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.cTime))]
      }
    }], null, false, 261302795)
  })], 1), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "margin": "10px 0",
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "current-page": _vm.pageIndexThree,
      "page-size": 10,
      "total": _vm.totalRowsCountThree
    },
    on: {
      "current-change": _vm.handleTabThree
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.statusMA == 3) ? _c('div', [_c('el-form', {
    staticClass: "findform",
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "50%"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "placeholder": "搜索店铺名称",
      "maxlength": "20"
    },
    model: {
      value: (_vm.filters.EnterpriseName),
      callback: function($$v) {
        _vm.$set(_vm.filters, "EnterpriseName", $$v)
      },
      expression: "filters.EnterpriseName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.dissolutionMA
    }
  }, [_vm._v("解散联盟")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.editMA
    }
  }, [_vm._v("编辑联盟信息")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.inviteMerchants
    }
  }, [_vm._v("邀请商家")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "table_container"
  }, [_c('el-table', {
    attrs: {
      "data": _vm.fourMAList,
      "stripe": "",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "align": "center",
      "width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.$index + 1))])]
      }
    }], null, false, 4178052834)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "店铺名称",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "spanList",
          attrs: {
            "title": scope.row.name
          }
        }, [_vm._v(_vm._s(scope.row.name))])]
      }
    }], null, false, 3754464004)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "负责人",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.contacts))]
      }
    }], null, false, 805193294)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "联系电话",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.phone))]
      }
    }], null, false, 2034370561)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "店铺类型",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.bbTypeName))]
      }
    }], null, false, 1483970594)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "邀请时间",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.cTime))]
      }
    }], null, false, 261302795)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.stateName))]
      }
    }], null, false, 2867331277)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.state == 2) ? _c('span', {
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.fourMATipsFun(scope.row, 1)
            }
          }
        }, [_vm._v(" 取消邀请 ")]) : _vm._e(), _vm._v(" "), (scope.row.state == 2) ? _c('span', {
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.fourMATipsFun(scope.row, 2)
            }
          }
        }, [_vm._v(" 通知商家 ")]) : _vm._e(), _vm._v(" "), (scope.row.state == 1) ? _c('span', {
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.fourMATipsFun(scope.row, 3)
            }
          }
        }, [_vm._v(" 移除商家 ")]) : _vm._e(), _vm._v(" "), (scope.row.state == 1) ? _c('span', {
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.sheweiMz(scope.row, 3)
            }
          }
        }, [_vm._v(" 设为盟主 ")]) : _vm._e()]
      }
    }], null, false, 1478653641)
  })], 1), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "margin": "10px 0",
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "current-page": _vm.pageIndexFour,
      "page-size": 10,
      "total": _vm.totalRowsCountFour
    },
    on: {
      "current-change": _vm.handleTabFour
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.statusMA == 4) ? _c('div', {
    staticClass: "displayFlex"
  }, [_c('el-card', {
    staticClass: "box-card card1",
    style: ('height:' + _vm.scrollbarHeight)
  }, [_c('el-tree', {
    ref: "rightsTree",
    staticClass: "lineheighttree",
    attrs: {
      "data": _vm.oneData,
      "props": _vm.defaultProps,
      "node-key": "id",
      "highlight-current": "",
      "default-checked-keys": _vm.defaultCheckedKeys
    },
    on: {
      "node-click": _vm.handleNodeClick
    }
  })], 1), _vm._v(" "), _c('el-card', {
    staticClass: "box-card card2",
    style: ('height:' + _vm.scrollbarHeight)
  }, [_c('el-form', {
    staticClass: "findform",
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "60%"
    },
    attrs: {
      "label": _vm.searchName,
      "label-width": "120px"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": '请输入' + _vm.searchName,
      "maxlength": "20"
    },
    model: {
      value: (_vm.filters.EnterpriseName),
      callback: function($$v) {
        _vm.$set(_vm.filters, "EnterpriseName", $$v)
      },
      expression: "filters.EnterpriseName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("查询")])], 1)], 1), _vm._v(" "), _c('el-table', {
    attrs: {
      "data": _vm.brandList,
      "row-key": _vm.getRowKey,
      "stripe": "",
      "border": ""
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "reserve-selection": true,
      "align": "center",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "序号",
      "align": "center",
      "width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.$index + 1))])]
      }
    }], null, false, 4178052834)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "店铺名称",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "spanList",
          attrs: {
            "title": scope.row.name
          }
        }, [_vm._v(_vm._s(scope.row.name))])]
      }
    }], null, false, 3754464004)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "负责人",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.contacts))]
      }
    }], null, false, 805193294)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "联系电话",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.phone))]
      }
    }], null, false, 2034370561)
  })], 1), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "margin": "10px 0",
      "width": "100%",
      "text-align": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "current-page": _vm.pageIndexFive,
      "page-size": 10,
      "total": _vm.totalRowsCountFive
    },
    on: {
      "current-change": _vm.handleTabFive
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.statusMA == 4) ? _c('div', {
    staticClass: "button_wrap2"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.returnSeeFuna
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "danger"
    },
    on: {
      "click": _vm.saveFun
    }
  }, [_vm._v("确定邀请")])], 1) : _vm._e(), _vm._v(" "), (_vm.statusMA == 2) ? _c('div', {
    staticStyle: {
      "margin": "15px 0",
      "text-align": "center"
    }
  }, [_c('el-button', {
    on: {
      "click": _vm.returnSeeFun
    }
  }, [_vm._v("返回")])], 1) : _vm._e(), _vm._v(" "), (_vm.statusMA == 3) ? _c('div', {
    staticStyle: {
      "margin": "15px 0",
      "text-align": "center"
    }
  }, [_c('el-button', {
    on: {
      "click": _vm.returnFun
    }
  }, [_vm._v("返回")])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeName == 'second'),
      expression: "activeName=='second'"
    }],
    staticClass: "main_container"
  }, [(_vm.statusMA == 1) ? _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "table_container"
  }, [_c('el-table', {
    attrs: {
      "data": _vm.twoList.resultObj,
      "stripe": "",
      "border": ""
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "align": "center",
      "width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.$index + 1))])]
      }
    }], null, false, 4178052834)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "联盟名称",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "spanList",
          attrs: {
            "title": scope.row.name
          }
        }, [_vm._v(_vm._s(scope.row.name))])]
      }
    }], null, false, 3754464004)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "联盟联系人",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.contacts))]
      }
    }], null, false, 805193294)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "联系电话",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.contactsPhone))]
      }
    }], null, false, 1248487762)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.stateName))]
      }
    }], null, false, 2867331277)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "邀请时间",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.cTime))]
      }
    }], null, false, 261302795)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "fixed": "right",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.state == 1) ? _c('span', {
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.invitationFun(scope.row, 1)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-circle-check"
        }), _vm._v(" 同意 ")]) : _vm._e(), _vm._v(" "), (scope.row.state == 1) ? _c('span', {
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.invitationFun(scope.row, 2)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-circle-close"
        }), _vm._v(" 拒绝 ")]) : _vm._e(), _vm._v(" "), _c('span', {
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.operationButton(scope.row, 4)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-view"
        }), _vm._v(" 查看 ")])]
      }
    }], null, false, 2665460273)
  })], 1), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "margin": "10px 0",
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "current-page": _vm.pageIndexTwo,
      "page-size": 10,
      "total": _vm.totalRowsCountTwo
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.statusMA == 2) ? _c('div', {
    staticStyle: {
      "padding-bottom": "100px"
    }
  }, [_c('p', {
    staticClass: "reminder"
  }, [_c('img', {
    staticClass: "faceUrl",
    attrs: {
      "src": _vm.basicInformation.logoUrl
    }
  }), _vm._v("\r\n        联盟名称:" + _vm._s(_vm.basicInformation.name) + "　　联盟联系人:" + _vm._s(_vm.basicInformation.contacts) + "　　联系电话:" + _vm._s(_vm.basicInformation.contactsPhone) + "\r\n      ")]), _vm._v(" "), _c('el-form', {
    staticClass: "findform",
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "50%"
    }
  }, [_c('el-input', {
    staticStyle: {
      "overflow": "hidden",
      "text-overflow": "ellipsis",
      "white-space": "nowrap"
    },
    attrs: {
      "placeholder": "搜索店铺名称",
      "maxlength": "20"
    },
    model: {
      value: (_vm.filters.EnterpriseName),
      callback: function($$v) {
        _vm.$set(_vm.filters, "EnterpriseName", $$v)
      },
      expression: "filters.EnterpriseName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("查询")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "table_container"
  }, [_c('el-table', {
    attrs: {
      "data": _vm.threeMAList,
      "stripe": "",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "align": "center",
      "width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.$index + 1))])]
      }
    }], null, false, 4178052834)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "店铺名称",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "spanList",
          attrs: {
            "title": scope.row.name
          }
        }, [_vm._v(_vm._s(scope.row.name))])]
      }
    }], null, false, 3754464004)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "负责人",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.contacts))]
      }
    }], null, false, 805193294)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "联系电话",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.phone))]
      }
    }], null, false, 2034370561)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "店铺类型",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.bbTypeName))]
      }
    }], null, false, 1483970594)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "加入时间",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.cTime))]
      }
    }], null, false, 261302795)
  })], 1), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "margin": "10px 0",
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "current-page": _vm.pageIndexThree,
      "page-size": 10,
      "total": _vm.totalRowsCountThree
    },
    on: {
      "current-change": _vm.handleTabThree
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.statusMA == 2) ? _c('div', {
    staticStyle: {
      "margin-bottom": "15px",
      "text-align": "center"
    }
  }, [_c('el-button', {
    on: {
      "click": _vm.returnSeeFun
    }
  }, [_vm._v("返回")])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeName == 'third'),
      expression: "activeName=='third'"
    }],
    staticClass: "main_container"
  }, [_c('el-form', {
    staticClass: "findform",
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "30%"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "placeholder": '请输入' + _vm.searchName,
      "maxlength": "20"
    },
    model: {
      value: (_vm.filters.EnterpriseName),
      callback: function($$v) {
        _vm.$set(_vm.filters, "EnterpriseName", $$v)
      },
      expression: "filters.EnterpriseName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        _vm.addEmployee = true
      }
    }
  }, [_vm._v("添加员工")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "table_container"
  }, [_c('el-table', {
    attrs: {
      "data": _vm.threeList,
      "stripe": "",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "align": "center",
      "width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.$index + 1))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "昵称",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "spanList",
          attrs: {
            "title": scope.row.name
          }
        }, [_vm._v(_vm._s(scope.row.name))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "手机号",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.phone))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "加入时间",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.userBindingTime))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "fixed": "right",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.deleteFun(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-delete"
        }), _vm._v(" 删除员工 ")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "margin": "10px 0",
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "current-page": _vm.pageIndexTabOne,
      "page-size": 10,
      "total": _vm.ygtotalRowsCount
    },
    on: {
      "current-change": _vm.handleTabOne
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeName == 'fourth'),
      expression: "activeName=='fourth'"
    }],
    staticClass: "main_container"
  }, [_c('div', {
    staticClass: "QRCodeClass"
  }, [_c('div', {
    staticStyle: {
      "width": "320px",
      "text-align": "center",
      "margin-bottom": "20px"
    }
  }, [_c('b', {
    staticStyle: {
      "line-height": "50px",
      "font-size": "16px",
      "display": "block"
    }
  }, [_vm._v("店铺码")]), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "260px",
      "height": "auto",
      "margin-bottom": "10px"
    },
    attrs: {
      "src": _vm.showImageUrl
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.xiazai()
      }
    }
  }, [_vm._v("下载店铺码")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "320px",
      "text-align": "center",
      "margin-bottom": "20px"
    }
  }, [_c('b', {
    staticStyle: {
      "line-height": "50px",
      "font-size": "16px",
      "display": "block"
    }
  }, [_vm._v("员工码")]), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "260px",
      "height": "auto",
      "margin-bottom": "10px"
    },
    attrs: {
      "src": _vm.staffQRCode
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.xiazaiYg()
      }
    }
  }, [_vm._v("下载员工码")]), _vm._v(" "), _c('br')], 1)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeName == 'fifth'),
      expression: "activeName=='fifth'"
    }],
    staticClass: "main_container"
  }, [_c('ActivityManagementList', {
    ref: "refLmhd",
    attrs: {
      "oneId": _vm.oneId,
      "oneName": _vm.oneName,
      "bbid": _vm.bbid
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeName == 'sixth'),
      expression: "activeName=='sixth'"
    }],
    staticClass: "main_container"
  }, [(_vm.statusMA == 5) ? _c('div', [_c('el-form', {
    staticClass: "findform"
  }, [_c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "margin-right": "15px"
    },
    attrs: {
      "label": ""
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请选择联盟"
    },
    model: {
      value: (_vm.maIdSix),
      callback: function($$v) {
        _vm.maIdSix = $$v
      },
      expression: "maIdSix"
    }
  }, _vm._l((_vm.options2), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "display": "flex"
    },
    attrs: {
      "label": ""
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "align": "right",
      "unlink-panels": "",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期",
      "value-format": "yyyy-MM-dd"
    },
    on: {
      "change": _vm.changeActiveTime
    },
    model: {
      value: (_vm.value2),
      callback: function($$v) {
        _vm.value2 = $$v
      },
      expression: "value2"
    }
  })], 1), _vm._v(" "), _c('el-radio-group', {
    staticStyle: {
      "margin-left": "15px"
    },
    on: {
      "change": function($event) {
        return _vm.radioType()
      }
    },
    model: {
      value: (_vm.tabPosition),
      callback: function($$v) {
        _vm.tabPosition = $$v
      },
      expression: "tabPosition"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "0"
    }
  }, [_vm._v("全部")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "1"
    }
  }, [_vm._v("近期3天")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "2"
    }
  }, [_vm._v("近期7天")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "3"
    }
  }, [_vm._v("近期1个月")])], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "15px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.onSubmitSixFun
    }
  }, [_vm._v("查询")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "table_container"
  }, [_c('el-table', {
    attrs: {
      "data": _vm.allianceDataList,
      "stripe": "",
      "border": ""
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "align": "center",
      "width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.$index + 1))])]
      }
    }], null, false, 4178052834)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "店铺名称",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "spanList",
          attrs: {
            "title": scope.row.name
          }
        }, [_vm._v(_vm._s(scope.row.name))])]
      }
    }], null, false, 3754464004)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "员工数（含店铺码）",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "color": "#409EFF"
          },
          on: {
            "click": function($event) {
              return _vm.employeeDimensionFun(scope.row.bbId)
            }
          }
        }, [_vm._v(_vm._s(scope.row.staffCount))])]
      }
    }], null, false, 3461597351)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "拉新用户数",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "color": "#409EFF"
          },
          on: {
            "click": function($event) {
              return _vm.pullNewFun(0, scope.row.bbId)
            }
          }
        }, [_vm._v(_vm._s(scope.row.newUserCount))])]
      }
    }], null, false, 1997948987)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "平台会员",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "color": "#409EFF"
          },
          on: {
            "click": function($event) {
              return _vm.pullNewFun(1, scope.row.bbId)
            }
          }
        }, [_vm._v(_vm._s(scope.row.newUserVIPCount))])]
      }
    }], null, false, 2916532501)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "交易笔数",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "color": "#409EFF"
          },
          on: {
            "click": function($event) {
              return _vm.orderDimensionFun(scope.row.bbId)
            }
          }
        }, [_vm._v(_vm._s(scope.row.newUserOrderCount))])]
      }
    }], null, false, 309457870)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "交易金额（元）",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "color": "#409EFF"
          },
          on: {
            "click": function($event) {
              return _vm.orderDimensionFun(scope.row.bbId)
            }
          }
        }, [_vm._v(_vm._s(scope.row.newUserOrderSum))])]
      }
    }], null, false, 2536987974)
  })], 1), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "float": "right",
      "margin": "10px 0"
    },
    attrs: {
      "layout": "prev, pager, next",
      "current-page": _vm.pageIndexSeventh,
      "page-size": 10,
      "total": _vm.totalRowsCountSeventh
    },
    on: {
      "current-change": _vm.handleTabSeventh
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.statusMA == 6) ? _c('div', [_c('div', {
    staticClass: "table_container"
  }, [_c('el-table', {
    attrs: {
      "data": _vm.EDList,
      "stripe": "",
      "border": ""
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "align": "center",
      "width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.$index + 1))])]
      }
    }], null, false, 4178052834)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "员工",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "spanList",
          attrs: {
            "title": scope.row.name
          }
        }, [_vm._v(_vm._s(scope.row.name))])]
      }
    }], null, false, 3754464004)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "拉新用户数",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "color": "#409EFF"
          },
          on: {
            "click": function($event) {
              return _vm.pullNewFun1(0, scope.row.id)
            }
          }
        }, [_vm._v(_vm._s(scope.row.newUserCount))])]
      }
    }], null, false, 791378026)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "平台会员",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "color": "#409EFF"
          },
          on: {
            "click": function($event) {
              return _vm.pullNewFun1(1, scope.row.id)
            }
          }
        }, [_vm._v(_vm._s(scope.row.newUserVIPCount))])]
      }
    }], null, false, 2079948932)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "交易笔数",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.newUserOrderCount))]
      }
    }], null, false, 2259052893)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "交易金额（元）",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.newUserOrderSum))]
      }
    }], null, false, 4157573589)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "佣金",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.commission))]
      }
    }], null, false, 3679886832)
  })], 1), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "margin": "10px 0",
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "current-page": _vm.pageIndexEighth,
      "page-size": 10,
      "total": _vm.totalRowsCountEighth
    },
    on: {
      "current-change": _vm.handleTabEighth
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.statusMA == 7) ? _c('div', [_c('div', {
    staticClass: "table_container"
  }, [_c('el-table', {
    attrs: {
      "data": _vm.ODList,
      "stripe": "",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "align": "center",
      "width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.$index + 1))])]
      }
    }], null, false, 4178052834)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "订单号",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "spanList",
          attrs: {
            "title": scope.row.orderNo
          }
        }, [_vm._v(_vm._s(scope.row.orderNo))])]
      }
    }], null, false, 2876370916)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "交易时间",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.cTime))]
      }
    }], null, false, 261302795)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "所属店铺",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.bbName))]
      }
    }], null, false, 668945242)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "用户昵称",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.userName))]
      }
    }], null, false, 2809081707)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "交易金额（元）",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.price))]
      }
    }], null, false, 3949003760)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "fixed": "right",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.seeOrderFun(scope.row.id)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-view"
        }), _vm._v(" 查看 ")])]
      }
    }], null, false, 2256484886)
  })], 1), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "margin": "10px 0",
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "current-page": _vm.pageIndexTenth,
      "page-size": 10,
      "total": _vm.totalRowsCountTenth
    },
    on: {
      "current-change": _vm.handleTabtenth
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.statusMA == 6 || _vm.statusMA == 7) ? _c('div', {
    staticStyle: {
      "margin": "15px 0",
      "text-align": "center"
    }
  }, [_c('el-button', {
    on: {
      "click": _vm.returnSixFun
    }
  }, [_vm._v("返回")])], 1) : _vm._e()]), _vm._v(" "), _c('el-drawer', {
    attrs: {
      "title": _vm.titSix,
      "custom-class": "registrationRecord",
      "visible": _vm.newUsersDrawer,
      "direction": "rtl",
      "size": "48%"
    },
    on: {
      "update:visible": function($event) {
        _vm.newUsersDrawer = $event
      }
    }
  }, [_c('el-table', {
    attrs: {
      "data": _vm.pullNewOrVipList,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "align": "center",
      "width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.$index + 1))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "name",
      "label": "用户昵称",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "phone",
      "label": "手机电话",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "newUserOrderCount",
      "label": "交易笔数",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "newUserOrderSum",
      "label": "交易金额(元)",
      "align": "center"
    }
  })], 1), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "float": "right",
      "margin-top": "10px"
    },
    attrs: {
      "layout": "prev, pager, next",
      "current-page": _vm.pageIndexSix,
      "page-size": 10,
      "total": _vm.totalRowsCountSix
    },
    on: {
      "current-change": _vm.handleTabSix
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.isShowImageDialog,
      "title": "查看大图"
    },
    on: {
      "update:visible": function($event) {
        _vm.isShowImageDialog = $event
      },
      "closed": _vm.clearImg
    }
  }, [_c('div', {
    staticClass: "imgDialog"
  }, [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "auto",
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "src": _vm.showImageUrl
    }
  })])]), _vm._v(" "), _c('el-drawer', {
    attrs: {
      "title": "订单详情",
      "custom-class": "registrationRecord",
      "visible": _vm.orderDetDrawer,
      "direction": "rtl",
      "size": "48%"
    },
    on: {
      "update:visible": function($event) {
        _vm.orderDetDrawer = $event
      }
    }
  }, [_c('div', {
    staticClass: "drawerDiv",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('ul', [_c('li', [_vm._v("订　单　号："), _c('span', [_vm._v(_vm._s(_vm.orderDet.orderNo))])]), _vm._v(" "), _c('li', [_vm._v("创　建　日　期："), _c('span', [_vm._v(_vm._s(_vm.orderDet.cTime))])]), _vm._v(" "), _c('li', [_vm._v("交　易　品　牌："), _c('span', [_c('strong', [_vm._v(_vm._s(_vm.orderDet.brandName))])])]), _vm._v(" "), _c('li', [_vm._v("付　款　门　店："), _c('span', [_vm._v(_vm._s(_vm.orderDet.store))])]), _vm._v(" "), _c('li', [_vm._v("商　品　总　价："), _c('span', [_vm._v(_vm._s(_vm.orderDet.totalPrice))])]), _vm._v(" "), _c('li', [_vm._v("用户 ："), _c('span', [_vm._v(_vm._s(_vm.orderDet.userName))])]), _vm._v(" "), _c('li', [_vm._v("用　户　电　话："), _c('span', [_vm._v(_vm._s(_vm.orderDet.userPhone))])]), _vm._v(" "), _c('li', [_vm._v("实　付　金　额："), _c('span', [_vm._v(_vm._s(_vm.orderDet.price))])]), _vm._v(" "), _c('li', [_vm._v("返　现　金　额："), _c('span', [_vm._v(_vm._s(_vm.orderDet.returnPrice))])]), _vm._v(" "), _c('li', [_vm._v("纸　质　凭　证：\r\n          "), _vm._l((_vm.orderDet.vouchers), function(item) {
    return _c('img', {
      key: item.orderNo,
      staticClass: "imgStyle",
      attrs: {
        "src": item
      },
      on: {
        "click": function($event) {
          return _vm.showDialog(item)
        }
      }
    })
  })], 2), _vm._v(" "), _c('li', [_vm._v("交　易　备　注："), _c('span', [_vm._v(_vm._s(_vm.orderDet.remark))])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "bottom": "-60px",
      "left": "50%"
    }
  }, [_c('el-button', {
    staticStyle: {
      "margin-top": "-10px"
    },
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        _vm.orderDetDrawer = false
      }
    }
  }, [_vm._v("关 闭")])], 1)])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "center": true,
      "title": _vm.isEdit ? '编辑联盟' : '创建联盟',
      "visible": _vm.createAllianceAdd,
      "width": "50%"
    },
    on: {
      "update:visible": function($event) {
        _vm.createAllianceAdd = $event
      }
    }
  }, [_c('el-form', {
    ref: "createAllianceForm",
    attrs: {
      "model": _vm.createAllianceForm,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "联盟名称:",
      "label-width": "100px",
      "prop": "allianceNickname"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "type": "text",
      "placeholder": "请输入联盟名称（不超过15个字）",
      "maxlength": "15"
    },
    model: {
      value: (_vm.createAllianceForm.allianceNickname),
      callback: function($$v) {
        _vm.$set(_vm.createAllianceForm, "allianceNickname", $$v)
      },
      expression: "createAllianceForm.allianceNickname"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "prop": "goodsImgUrl",
      "label": "联盟LOGO:",
      "label-width": "100px"
    }
  }, [_c('div', {
    staticClass: "uploadActive"
  }, [_c('el-upload', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isdisabled),
      expression: "isdisabled"
    }],
    staticClass: "avatar-uploader proportionImg",
    attrs: {
      "action": "",
      "show-file-list": false,
      "before-upload": _vm.beforeAvatarUpload
    }
  }, [(_vm.goodsImgUrl) ? _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('img', {
    staticClass: "chahao",
    attrs: {
      "src": require("../../assets/img/aicon36.png")
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.deleteIconFun($event)
      }
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "80px",
      "height": "80px"
    },
    attrs: {
      "src": _vm.goodsImgUrl
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.goodsImgUrl) ? _c('div', [_c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })]) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#888"
    }
  }, [_vm._v(" 建议尺寸：比例为1 : 1　支持的图片格式：jpg、png ")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联盟联系人:",
      "prop": "allianceName",
      "label-width": "100px"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "type": "text",
      "placeholder": "请输入联盟姓名",
      "maxlength": "10"
    },
    model: {
      value: (_vm.createAllianceForm.allianceName),
      callback: function($$v) {
        _vm.$set(_vm.createAllianceForm, "allianceName", $$v)
      },
      expression: "createAllianceForm.allianceName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系电话:",
      "prop": "alliancePhone",
      "label-width": "100px"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "type": "text",
      "placeholder": "请输入联盟电话",
      "maxlength": "11"
    },
    model: {
      value: (_vm.createAllianceForm.alliancePhone),
      callback: function($$v) {
        _vm.$set(_vm.createAllianceForm, "alliancePhone", $$v)
      },
      expression: "createAllianceForm.alliancePhone"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.createAllianceAdd = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.newMAFun()
      }
    }
  }, [_vm._v("确定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "center": true,
      "title": "重要提示",
      "visible": _vm.importantIips,
      "width": "30%"
    },
    on: {
      "update:visible": function($event) {
        _vm.importantIips = $event
      }
    }
  }, [_c('el-form', {
    staticClass: "findform"
  }, [_vm._v("\r\n      " + _vm._s(_vm.tipsText) + "\r\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.importantIips = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.sureTipsFun()
      }
    }
  }, [_vm._v("确定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "添加员工",
      "visible": _vm.addEmployee,
      "width": "30%",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.addEmployee = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "text-align": "center",
      "margin-bottom": "20px"
    }
  }, [_c('b', [_vm._v("操作提示：请让员工打开微信进行扫码，即可添加员工。")]), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "260px",
      "height": "auto",
      "margin": "20px 0 10px 0"
    },
    attrs: {
      "src": _vm.staffQRCode
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.xiazaiYg()
      }
    }
  }, [_vm._v("下载员工码")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "center": true,
      "title": "解散联盟",
      "visible": _vm.dissolutionPopup,
      "width": "30%",
      "closeOnClickModal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dissolutionPopup = $event
      }
    }
  }, [_c('el-form', [_c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_vm._v("您确定要解散当前联盟吗？此操作不可逆，请谨慎操作！")]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-bottom": "0"
    },
    attrs: {
      "label": "联系人:",
      "prop": "allianceName"
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.dismissPhone))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "pr",
    attrs: {
      "label": "验证码:",
      "prop": "code"
    }
  }, [_c('el-input', {
    staticClass: "print",
    attrs: {
      "prop": "code",
      "placeholder": "验证码"
    },
    model: {
      value: (_vm.loginForm.code),
      callback: function($$v) {
        _vm.$set(_vm.loginForm, "code", $$v)
      },
      expression: "loginForm.code"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "code-btn",
    attrs: {
      "disabled": !_vm.show
    },
    on: {
      "click": function($event) {
        return _vm.getCode()
      }
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }]
  }, [_vm._v("发送验证码")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.show),
      expression: "!show"
    }],
    staticClass: "count"
  }, [_vm._v(_vm._s(_vm.count) + " s")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dissolutionPopup = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.sureVCordFun()
      }
    }
  }, [_vm._v("确定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "确认提示",
      "visible": _vm.mengzhu,
      "width": "25%",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.mengzhu = $event
      },
      "closed": _vm.clearMz
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-bottom": "30px"
    }
  }, [_vm._v("确定要将“" + _vm._s(_vm.mzName) + "”店设置为盟主店吗？")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.mengzhu = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.defineMz()
      }
    }
  }, [_vm._v("确定")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "center": true,
      "title": "请选择店铺",
      "visible": _vm.dialogVisibleadd,
      "width": "26%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisibleadd = $event
      }
    }
  }, [_c('el-form', {
    staticClass: "findform"
  }, [_c('el-form-item', {
    staticStyle: {
      "display": "flex"
    },
    attrs: {
      "label": "店铺名称："
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请选择店铺"
    },
    model: {
      value: (_vm.bbid),
      callback: function($$v) {
        _vm.bbid = $$v
      },
      expression: "bbid"
    }
  }, _vm._l((_vm.options1), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.gonext()
      }
    }
  }, [_vm._v("确定")])], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "model_section"
  }, [_c('p', {
    staticClass: "model_top_title"
  }, [_vm._v("入盟邀请")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-bac43992!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/operationManagement/merchantAlliance.vue
// module id = 1740
// module chunks = 3